'use client'

import { MessageCircle } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'

import { FeedbackDialog } from './organisms/feedback-dialog'

export const FeedbackButton = () => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton onClick={() => setOpen(true)} size="lg">
            <MessageCircle />
            <span>{t('sidebar.feedback')}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
      <FeedbackDialog open={open} onOpenChange={setOpen} />
    </>
  )
}
